export function marketRealtimeSubscriptionId(market) {
  return String(market?.id || "").trim();
}
